import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  getReport: function (parameters) {
    return axios.get('/api/analytics/routing/report', {params: parameters});
  },
  exportReport: function(parameters) {
    return Utils.downloadFile('/api/analytics/routing/exportreport', "ReportRouting.xlsx", parameters);
  },
  getReportFields: function() {
    return axios.get('/api/analytics/routing/fields');
  }
}